import { configureStore} from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import rootReducer from '../Reducers/rootReducer';

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);

